/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import './MobileBackButton.scss';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import type { RouterHistory } from 'react-router-dom';

import { greyDark } from '../../constants/colors';
import { edgeAriaLabel } from '../../helpers';

interface Props {
  text?: string;
  history: RouterHistory;
  onDesktopClick?: () => void;
  pageJumpCount: number;
}

const className = 'c-MobileBackButton';
const buttonId = 'MobileBackButton__goBack';
const LINK_LABEL = 'Go back';

export const MobileBackButton = ({ text = 'Back', history }: Props) => {
  const handleChangePage = () => history.goBack();

  return (
    <button
      type="button"
      className={`${className}__button`}
      id={buttonId}
      data-testid={buttonId}
      onClick={handleChangePage}
      aria-label={LINK_LABEL}
    >
      {edgeAriaLabel(LINK_LABEL)}
      <FontAwesomeIcon
        icon={faArrowLeft}
        color={greyDark}
        className={`${className}__arrowLeft`}
        aria-label={"back arrow icon"}
        alt={"back arrow icon"}
      />
      <span className={`${className}__text`}>{text}</span>
    </button>
  );
};

export default MobileBackButton;
